export default __webpack_public_path__ + "static/lady_cleaning_dishes-d5001b1735ef18af90011614d4829622.jpeg";